export const Loading = require('../resources/img/loading.gif');
export const Back = require('../resources/img/cheveronback.webp');